import { combineReducers } from 'redux';

import home from './home';
import common from './common';

export default combineReducers({
  home,
  common
});
